<template>
  <SettingsWrapper @close="$emit('close')" @save="save">
    <div class="divide-y divide-gray-200 p-6 px-8 py-0">
      <div class="space-y-1">
        <h3 class="text-lg font-medium leading-6 text-gray-900">Analytics options</h3>
        <p class="max-w-2xl text-sm text-gray-500">Enable only the services you intend to use, to prevent unused code on your website.</p>
      </div>
      <div class="mt-6">
        <dl class="divide-y divide-gray-200">
          <AnalyticsSection
            v-model="$v.enableGoogleAnalytics.$model"
            title="Google Analytics"
          >
            <div class="mt-4 grid gap-4">
              <div>
                <label for="host" class="block text-sm font-medium text-gray-700">Google Tag ID</label>
                <div class="mt-1  w-full">
                  <input v-model="$v.googleTagId.$model" type="text" placeholder="G-JTF23NEO5J" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
                </div>
              </div>
            </div>
          </AnalyticsSection>
          <AnalyticsSection
            v-model="$v.enableHotjar.$model"
            title="Hotjar"
          >
            <div class="mt-4 grid gap-4">
              <div>
                <label for="host" class="block text-sm font-medium text-gray-700">Hotjar ID</label>
                <div class="mt-1  w-full">
                  <input v-model="$v.hotjarId.$model" type="text" placeholder="21324280" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
                </div>
              </div>
            </div>
          </AnalyticsSection>
          <AnalyticsSection
            v-model="$v.facebookPixelEnable.$model"
            title="Facebook Pixel"
          >
            <div class="mt-4 grid gap-4">
              <div>
                <label for="host" class="block text-sm font-medium text-gray-700">Pixel ID</label>
                <div class="mt-1  w-full">
                  <input v-model="$v.facebookPixelId.$model" type="text" placeholder="1148418453549902" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
                </div>
              </div>
            </div>
          </AnalyticsSection>
          <AnalyticsSection
            v-model="$v.logRocketEnable.$model"
            title="Log Rocket"
          >
            <div class="mt-4 grid gap-4">
              <div>
                <label for="host" class="block text-sm font-medium text-gray-700">App ID</label>
                <div class="mt-1  w-full">
                  <input v-model="$v.logRocketAppId.$model" type="text" placeholder="" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
                </div>
              </div>
            </div>
          </AnalyticsSection>
          <AnalyticsSection
            v-model="$v.openReplayEnable.$model"
            title="Open Replay"
          >
            <!--       openReplayEnable: "openreplay/enable",
              openReplayProjectKey: "openreplay/projectkey",
              ingestPoint: "openreplay/ingest_point",
              defaultInputMode: "openreplay/default_input_mode",
              obscureTextNumbers: "openreplay/obscure_text_numbers",
              obscureTextEmails: "openreplay/obscure_text_emails",
            },
            defaultDataValues: {
              defaultInputMode: 0,
              obscureTextNumbers: false,
              obscureTextEmails: true,
            },     -->
            <div class="mt-4 grid-cols-2 grid gap-4">
              <div>
                <label for="host" class="block text-sm font-medium text-gray-700">Project Key</label>
                <div class="mt-1  w-full">
                  <input v-model="$v.openReplayProjectKey.$model" type="text" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
                </div>
              </div>
              <div>
                <label for="host" class="block text-sm font-medium text-gray-700">Ingest Point</label>
                <div class="mt-1  w-full">
                  <input v-model="$v.ingestPoint.$model" type="text" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
                </div>
              </div>
              <div>
                <label for="host" class="block text-sm font-medium text-gray-700">Default Input Mode</label>
                <div class="mt-1  w-full">
                  <input v-model="$v.defaultInputMode.$model" type="text" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
                </div>
              </div>
              <div class="relative flex items-center">
                <div class="flex h-5 items-center">
                  <input v-model="$v.obscureTextNumbers.$model" id="text-numbers" name="text-numbers" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500">
                </div>
                <div class="ml-3 text-sm">
                  <label for="text-numbers" class="font-medium text-gray-700">Obscure Text Numbers</label>
                </div>
              </div>
              <div class="relative flex items-center">
                <div class="flex h-5 items-center">
                  <input v-model="$v.obscureTextEmails.$model" id="text-emails" name="text-emails" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500">
                </div>
                <div class="ml-3 text-sm">
                  <label for="text-emails" class="font-medium text-gray-700">Obscure Text Emails</label>
                </div>
              </div>
            </div>
          </AnalyticsSection>
        </dl>
      </div>
    </div>
  </SettingsWrapper>
</template>

<script>

import SettingsWrapper from "./../SettingsWrapper"
import websitePropertiesHelper from "@/components/SideEditor/website-properties-helper"

import AnalyticsSection from "./AnalyticsSection"

export default {
  components: {
    SettingsWrapper,
    AnalyticsSection,
  },
  mixins: [
    websitePropertiesHelper({
      success: "Successfully saved analytics settings!",

      key: "analytics",
      fieldMap: {
        enableGoogleAnalytics: "google/analytics/enable",
        googleTagId: "google/analytics/tagid",

        enableHotjar: "hotjar/enable",
        hotjarId: "hotjar/id",

        facebookPixelEnable: "facebook/pixel/enable",
        facebookPixelId: "facebook/pixel/id",

        logRocketEnable: "logrocket/enable",
        logRocketAppId: "logrocket/appid",

        openReplayEnable: "openreplay/enable",
        openReplayProjectKey: "openreplay/projectkey",
        ingestPoint: "openreplay/ingest_point",
        defaultInputMode: "openreplay/default_input_mode",
        obscureTextNumbers: "openreplay/obscure_text_numbers",
        obscureTextEmails: "openreplay/obscure_text_emails",
      },
      defaultDataValues: {
        defaultInputMode: 0,
        obscureTextNumbers: false,
        obscureTextEmails: true,
      },
    }),
  ],
}

</script>
